var _excluded = ["children", "isError", "onDismiss", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 *
 * A component that displays a flash message.
 *
 * @name FlashMessage
 * @type Function
 * @param {String} children - The flash message that will be displayed.
 * @param {Boolean} [isError=false] - A flag to indicate whether the message is an error message.
 * @param {Function} [onDismiss] - A callback for dismissing the flash message. The dismiss button will only be shown if this callback is provided.
 * @example
 *
 * function MyView () {
 *   const [message, setMessage] = useState(null)
 *   return (
 *      <div>
 *        {
 *           message &&
 *           <FlashMessage>{message}</FlashMessage>)
 *        }
 *        <button onClick={() => setMessage('Hi!')}> Show message </button>
 *      </div>
 *   )
 * }
 *
 */

var propTypes = {
  children: PropTypes.node.isRequired,
  isError: PropTypes.bool,
  onDismiss: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  isError: false,
  onDismiss: null,
  className: ''
};
function FlashMessage(_ref) {
  var children = _ref.children,
    isError = _ref.isError,
    onDismiss = _ref.onDismiss,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var statusClass = isError ? 'failure' : 'success';
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classnames('flash-message', statusClass, className)
  }, rest), onDismiss && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dismiss",
    onClick: function onClick() {
      return onDismiss();
    },
    "aria-label": "Dismiss"
  }, "\xD7"), children);
}
FlashMessage.propTypes = propTypes;
FlashMessage.defaultProps = defaultProps;
export default FlashMessage;